export default class PhoneNumberModel {
    countryCode:string|undefined;
    cellNumber:string|undefined;
}